<template>
  <div class="not-found">
    <div class="container">
      <h1>404</h1>
      <h2>页面未找到</h2>
      <p>抱歉，您请求的页面不存在或已被移除。</p>
      <router-link to="/" class="btn btn-primary">返回首页</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style scoped>
.not-found {
  text-align: center;
  padding: 100px 0;
}

h1 {
  font-size: 72px;
  margin-bottom: 20px;
  color: #e74c3c;
}

h2 {
  font-size: 32px;
  margin-bottom: 20px;
}

p {
  font-size: 18px;
  margin-bottom: 30px;
}
</style>